import { NamePath } from 'antd/es/form/interface';

export const concatJsonFormKey = (...keys: (NamePath | undefined)[]) => {
    let result: Array<string | number> = [];
    keys.forEach(key => {
        if (key instanceof Array) {
            result = [...result, ...key.filter(one => one !== undefined)];
        } else if (key !== undefined) {
            result = [...result, key];
        }
    });
    return result;
};
